module.exports = {
    purge: [],
    theme: {
      extend: {
        colors: {
          green: {
            100: '#b3ff63',
            200: '#9feb4f',
            300: '#8bd73b',
            400: '#77c327',
            500: '#63AF13',
            600: '#4f9b00',
            700: '#3b8700',
            800: '#277300',
            900: '#135f00'
          },
        },
      },
    },
    variants: {},
    plugins: [],
  }